import { createSelector } from '@ngrx/store';
import { AppState } from '..';

export const selectMasterdataState$ = (state: AppState) => state.masterdata;

export const selectMasterdata$ = createSelector(selectMasterdataState$, (masterdata) => masterdata.data);

export  const  selectMasterdataLoading$ = createSelector(selectMasterdataState$, (masterdata) =>  masterdata.loading);

export  const  selectMasterdataLoaded$ = createSelector(selectMasterdataState$, (masterdata) =>  masterdata.loaded);

export const selectOutdatedHorizons$ =
    createSelector(
        selectMasterdata$,
        (masterData) =>
            masterData
                .outdatedHorizons ??
            [],
    );

export const selectOutdatedHorizonUpdating$ =
    createSelector(
        selectMasterdataState$,
        (masterdata) =>
            masterdata.horizonUpdating,
    );

export const selectOutdatedHorizonDeleting$ =
    createSelector(
        selectMasterdataState$,
        (masterdata) =>
            masterdata.horizonDeleting,
    );

export const selectOutdatedHorizonError$ =
    createSelector(
        selectMasterdataState$,
        (masterdata) =>
            masterdata.horizonError,
    );
